import React from 'react';
import { Card, CardContent, Badge } from '@ncoder/ui';
import { GitCommit, Users, Clock, FileText, Eye } from 'lucide-react';
import { Button } from '@ncoder/ui';

export interface CommitData {
  id: string;
  message: string;
  author: string;
  date: string;
  branch: string;
  files: number;
  additions: number;
  deletions: number;
}

interface CommitCardProps {
  commit: CommitData;
  onViewDetails?: (commitId: string) => void;
}

export const CommitCard: React.FC<CommitCardProps> = ({ commit, onViewDetails }) => {
  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <code className="bg-muted px-2 py-1 text-xs rounded">{commit.id}</code>
              <Badge variant="outline" className="text-xs">{commit.branch}</Badge>
            </div>
            <p className="font-medium mb-1">{commit.message}</p>
            <div className="flex items-center gap-4 text-sm text-muted-foreground">
              <div className="flex items-center gap-1">
                <Users className="h-3 w-3" />
                {commit.author}
              </div>
              <div className="flex items-center gap-1">
                <Clock className="h-3 w-3" />
                {commit.date}
              </div>
              <div className="flex items-center gap-1">
                <FileText className="h-3 w-3" />
                {commit.files} files
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-green-600 text-sm">+{commit.additions}</span>
            <span className="text-red-600 text-sm">-{commit.deletions}</span>
            {onViewDetails && (
              <Button variant="ghost" size="sm" onClick={() => onViewDetails(commit.id)}>
                <Eye className="h-4 w-4" />
              </Button>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
